export default "__VITE_ASSET__2e31f5f7__"